<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Current Jobs</h3>
    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>

    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header"
      @row-selected="onRowSelected"
      :selectable="selected.selectable"
      :key="selected.selectable"
      :busy="working"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'active_end_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.active_end_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'active_start_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.active_start_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'actual_pier_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.actual_pier_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'base_inspector_supplier'">
            <o-form-select
              v-model="list_options.qbe.base_inspector_supplier"
              :options="steelSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="base_inspector_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'bob_cat'">
            <o-form-select
              v-model="list_options.qbe.bob_cat"
              :options="bobcatSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="bob_cat"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'bob_cat_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.bob_cat_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'bob_cat_ohs'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.bob_cat_ohs"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'comments'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.comments"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'concrete_notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.concrete_notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'concrete_order'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.concrete_order"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'created_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.created_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'crew_supplier'">
            <o-form-select
              v-model="list_options.qbe.crew_supplier"
              :options="optionCrewItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionCrewWorking"
              @change="filter_changed"
              name="crew_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'crew_leader'">
            <o-form-select
              v-model="list_options.qbe.crew_leader"
              :options="optionEmployeeItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionEmployeeWorking"
              @change="filter_changed"
              name="crew_leader"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'customer'">
            <o-form-select
              v-model="list_options.qbe.customer"
              :options="optionCustomerItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionCustomerWorking"
              @change="filter_changed"
              name="customer"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'date_call_up_received'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.date_call_up_received"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'date_sent_to_myob'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.date_sent_to_myob"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'drain_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.drain_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'drilled'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.drilled"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'files'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.files"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'inspector'">
            <o-form-select
              v-model="list_options.qbe.inspector"
              :options="steelSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="inspector"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'invoices'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.invoices"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'is_pier_passed'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.is_pier_passed"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'job_location'">
            <o-form-select
              v-model="list_options.qbe.job_location"
              :options="optionCodeJobLocationItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              blank-option-text=""
              :loading="optionCodeJobLocationWorking"
              @change="filter_changed"
              name="job_location"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'job_task'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.job_task"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'job_type'">
            <o-form-select
              v-model="list_options.qbe.job_type"
              :options="optionCodeJobTypeItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              blank-option-text=""
              :loading="optionCodeJobTypeWorking"
              @change="filter_changed"
              name="job_type"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'lot_no'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.lot_no"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'm2'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.m2"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'mobile_phone_no'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.mobile_phone_no"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'modified_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.modified_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'no_of_piers'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.no_of_piers"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'ohs'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.ohs"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'original_data'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.original_data"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'original_job_number'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.original_job_number"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'part_a_required'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.part_a_required"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'part_a_supplier'">
            <o-form-select
              v-model="list_options.qbe.part_a_supplier"
              :options="partASupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="part_a_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'pickup_items'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.pickup_items"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'pier_booking_no'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.pier_booking_no"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'pier_concrete_confirmed'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_concrete_confirmed"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'pier_concrete_notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.pier_concrete_notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'pier_concrete_supplier'">
            <o-form-select
              v-model="list_options.qbe.pier_concrete_supplier"
              :options="concreteSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="pier_concrete_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'pier_concrete_time'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_concrete_time"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pier_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pier_inspection_approved'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_inspection_approved"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'pier_inspection_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_inspection_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pier_inspector_supplier'">
            <o-form-select
              v-model="list_options.qbe.pier_inspector_supplier"
              :options="steelSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="pier_inspector_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'pier_ohs'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pier_ohs"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'pier_poured_by'">
            <o-form-select
              v-model="list_options.qbe.pier_poured_by"
              :options="optionCrewItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionCrewWorking"
              @change="filter_changed"
              name="pier_poured_by"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'pier_pump_supplier'">
            <o-form-select
              v-model="list_options.qbe.pier_pump_supplier"
              :options="pumpSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="pier_pump_supplier"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'piers_concrete_ordered'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.piers_concrete_ordered"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'piers_crew'">
            <o-form-select
              v-model="list_options.qbe.piers_crew"
              :options="piersSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="piers_crew"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'piers_excavator'">
            <o-form-select
              v-model="list_options.qbe.piers_excavator"
              :options="piersSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="piers_excavator"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'plan_provided'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.plan_provided"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'pod_picked_up_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pod_picked_up_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pour_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pour_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pre_slab_booked_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pre_slab_booked_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pre_slab_booking_no'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.pre_slab_booking_no"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'pre_slab_inspection_passed'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pre_slab_inspection_passed"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'pre_slab_notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.pre_slab_notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'pre_slab_passed'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pre_slab_passed"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'pump'">
            <o-form-select
              v-model="list_options.qbe.pump"
              :options="pumpSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="pump"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'pump_ohs'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.pump_ohs"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'purchase_order_number'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.purchase_order_number"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'replaced_data'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.replaced_data"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'retaining_walls_actual_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.retaining_walls_actual_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'retaining_walls_received_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.retaining_walls_received_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'retaining_walls_wanted_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.retaining_walls_wanted_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'revisit_comment'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.revisit_comment"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'revisit_required'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.revisit_required"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'rock_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.rock_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'rock_m2'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.rock_m2"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'set_out_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.set_out_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'site_address'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.site_address"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'site_cut'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'site_cut_crew'">
            <o-form-select
              v-model="list_options.qbe.site_cut_crew"
              :options="sitecutSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="site_cut_crew"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'site_cut_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'site_cut_date_received'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut_date_received"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'site_cut_ohs'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut_ohs"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'site_cut_percentage_done'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.site_cut_percentage_done"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'site_cut_retaining_walls'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut_retaining_walls"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'site_cut_spoil'">
            <o-form-select
              v-model="list_options.qbe.site_cut_spoil"
              :options="spoilSupplierType"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="site_cut_spoil"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'site_cut_tipsite'">
            <o-form-select
              v-model="list_options.qbe.site_cut_tipsite"
              :options="optionSupplierItems"
              text-field="display_name"
              value-field="id"
              sort-field="display_name"
              blank-option-text=""
              :loading="optionSupplierWorking"
              @change="filter_changed"
              name="site_cut_tipsite"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'site_cut_wanted_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.site_cut_wanted_date"
              hide-time
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'steel_booking_number'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.steel_booking_number"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'steel_inspection_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.steel_inspection_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'steel_inspection_passed'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.steel_inspection_passed"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'steel_notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.steel_notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'steel_ordered'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.steel_ordered"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'suburb'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.suburb"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'supervisor'">
            <o-form-select
              v-model="list_options.qbe.supervisor"
              :options="optionSupervisorItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              blank-option-text=""
              :loading="optionSupervisorWorking"
              @change="filter_changed"
              name="supervisor"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'termite_part_a_booking_no'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.termite_part_a_booking_no"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'termite_part_a_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.termite_part_a_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'wanted_pour_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.wanted_pour_date"
            ></o-flatpickr-wrapper>
          </span>
        </td>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(actual_pier_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'actual_pier_date'"
        >
          <date-display
            :value="item.actual_pier_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(base_inspector_supplier)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'base_inspector_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.base_inspector_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.bob_cat"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat_date'"
        >
          <date-display
            :value="item.bob_cat_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(bob_cat_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'bob_cat_ohs'"
        >
          <boolean-display :value="item.bob_cat_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display :value="item.comments"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(concrete_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'concrete_notes'"
        >
          <default-display :value="item.concrete_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(concrete_order)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'concrete_order'"
        >
          <date-display
            :value="item.concrete_order"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(create_request)" slot-scope="{ index, item }">
        <b-button @click="createRepair(item)" variant="primary"
          >Create Repair</b-button
        >
      </template>
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(crew_supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'crew_supplier'"
        >
          <lookup-display
            :list="optionCrewItemsById"
            :value="item.crew_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(crew_leader)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'crew_leader'"
        >
          <lookup-display
            :list="optionEmployeeItemsById"
            :value="item.crew_leader"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(customer)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'customer'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.customer"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_call_up_received)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_call_up_received'"
        >
          <date-display
            :value="item.date_call_up_received"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_sent_to_myob)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_sent_to_myob'"
        >
          <date-display
            :value="item.date_sent_to_myob"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(drain_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'drain_date'"
        >
          <date-display
            :value="item.drain_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(drilled)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'drilled'"
        >
          <boolean-display :value="item.drilled"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'files'"
        >
          <default-display :value="item.files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(inspector)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'inspector'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.inspector"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <default-display :value="item.invoices"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(is_pier_passed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'is_pier_passed'"
        >
          <boolean-display :value="item.is_pier_passed"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_location)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_location'"
        >
          <lookup-display
            :list="optionCodeJobLocationItemsById"
            :value="item.job_location"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_task)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_task'"
        >
          <default-display :value="item.job_task"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(job_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'job_type'"
        >
          <lookup-display
            :list="optionCodeJobTypeItemsById"
            :value="item.job_type"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(lot_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'lot_no'"
        >
          <default-display :value="item.lot_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(m2)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'm2'"
        >
          <number-display :value="item.m2" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(mobile_phone_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'mobile_phone_no'"
        >
          <default-display :value="item.mobile_phone_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(no_of_piers)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'no_of_piers'"
        >
          <number-display :value="item.no_of_piers" :decimals="0" />
        </o-link-cell>
      </template>
      <template slot="cell(notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'notes'"
        >
          <default-display :value="item.notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'ohs'"
        >
          <boolean-display :value="item.ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(original_data)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'original_data'"
        >
          {{ item.original_data }}
        </o-link-cell>
      </template>
      <template slot="cell(original_job_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'original_job_number'"
        >
          <default-display :value="item.original_job_number"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(part_a_required)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'part_a_required'"
        >
          <boolean-display :value="item.part_a_required"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(part_a_supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'part_a_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.part_a_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pickup_items)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pickup_items'"
        >
          <default-display :value="item.pickup_items"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_booking_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_booking_no'"
        >
          <default-display :value="item.pier_booking_no"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pier_concrete_confirmed)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_concrete_confirmed'"
        >
          <boolean-display
            :value="item.pier_concrete_confirmed"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_concrete_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_concrete_notes'"
        >
          <default-display :value="item.pier_concrete_notes"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pier_concrete_supplier)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_concrete_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.pier_concrete_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_concrete_time)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_concrete_time'"
        >
          <date-display
            :value="item.pier_concrete_time"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_date'"
        >
          <date-display
            :value="item.pier_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pier_inspection_approved)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_inspection_approved'"
        >
          <boolean-display
            :value="item.pier_inspection_approved"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_inspection_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_inspection_date'"
        >
          <date-display
            :value="item.pier_inspection_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pier_inspector_supplier)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_inspector_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.pier_inspector_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_ohs'"
        >
          <boolean-display :value="item.pier_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_poured_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_poured_by'"
        >
          <lookup-display
            :list="optionCrewItemsById"
            :value="item.pier_poured_by"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pier_pump_supplier)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pier_pump_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.pier_pump_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(piers_concrete_ordered)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'piers_concrete_ordered'"
        >
          <number-display :value="item.piers_concrete_ordered" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(piers_crew)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'piers_crew'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.piers_crew"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(piers_excavator)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'piers_excavator'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.piers_excavator"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(plan_provided)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'plan_provided'"
        >
          <boolean-display :value="item.plan_provided"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pod_picked_up_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pod_picked_up_date'"
        >
          <date-display
            :value="item.pod_picked_up_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pour_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pour_date'"
        >
          <date-display
            :value="item.pour_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_booked_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_booked_date'"
        >
          <date-display
            :value="item.pre_slab_booked_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_booking_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_booking_no'"
        >
          <default-display :value="item.pre_slab_booking_no"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(pre_slab_inspection_passed)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_inspection_passed'"
        >
          <boolean-display
            :value="item.pre_slab_inspection_passed"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_notes'"
        >
          <default-display :value="item.pre_slab_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(pre_slab_passed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pre_slab_passed'"
        >
          <date-display
            :value="item.pre_slab_passed"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(pump)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pump'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.pump"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(pump_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'pump_ohs'"
        >
          <boolean-display :value="item.pump_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(replaced_data)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'replaced_data'"
        >
          {{ item.replaced_data }}
        </o-link-cell>
      </template>
      <template
        slot="cell(retaining_walls_actual_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'retaining_walls_actual_date'"
        >
          <date-display
            :value="item.retaining_walls_actual_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(retaining_walls_received_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'retaining_walls_received_date'"
        >
          <date-display
            :value="item.retaining_walls_received_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(retaining_walls_wanted_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'retaining_walls_wanted_date'"
        >
          <date-display
            :value="item.retaining_walls_wanted_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(revisit_comment)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'revisit_comment'"
        >
          <default-display :value="item.revisit_comment"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(revisit_required)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'revisit_required'"
        >
          <boolean-display :value="item.revisit_required"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(rock_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'rock_date'"
        >
          <date-display
            :value="item.rock_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(rock_m2)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'rock_m2'"
        >
          <number-display :value="item.rock_m2" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(set_out_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'set_out_date'"
        >
          <date-display
            :value="item.set_out_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut'"
        >
          <boolean-display :value="item.site_cut"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_crew)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_crew'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.site_cut_crew"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_date'"
        >
          <date-display
            :value="item.site_cut_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_date_received)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_date_received'"
        >
          <date-display
            :value="item.site_cut_date_received"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_ohs)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_ohs'"
        >
          <boolean-display :value="item.site_cut_ohs"></boolean-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_percentage_done)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_percentage_done'"
        >
          <number-display
            :value="item.site_cut_percentage_done"
            :decimals="0"
          />
        </o-link-cell>
      </template>
      <template
        slot="cell(site_cut_retaining_walls)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_retaining_walls'"
        >
          <boolean-display
            :value="item.site_cut_retaining_walls"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_spoil)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_spoil'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.site_cut_spoil"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_tipsite)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_tipsite'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.site_cut_tipsite"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_cut_wanted_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_cut_wanted_date'"
        >
          <date-display
            :value="item.site_cut_wanted_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_booking_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_booking_number'"
        >
          <default-display :value="item.steel_booking_number"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_inspection_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_inspection_date'"
        >
          <date-display
            :value="item.steel_inspection_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(steel_inspection_passed)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_inspection_passed'"
        >
          <boolean-display
            :value="item.steel_inspection_passed"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_notes'"
        >
          <default-display :value="item.steel_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(steel_ordered)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'steel_ordered'"
        >
          <boolean-display :value="item.steel_ordered"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <lookup-display
            :list="optionSupervisorItemsById"
            :value="item.supervisor"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(termite_part_a_booking_no)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'termite_part_a_booking_no'"
        >
          <default-display
            :value="item.termite_part_a_booking_no"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(termite_part_a_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'termite_part_a_date'"
        >
          <date-display
            :value="item.termite_part_a_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(wanted_pour_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'job.edit', params: { id: item.id } }"
          :when="first_column_key === 'wanted_pour_date'"
        >
          <date-display
            :value="item.wanted_pour_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'job.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin";

import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import { mapActions, mapMutations } from "vuex";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    HasGroupMixin("Administrator"),

    CreateListPageMixin("Job", "job"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("Job"),
    CreateCodeTableFetchMixin([
      "CodeJobLocation",
      "CodeJobType",
      "Customer",
      "Supplier",
      "Employee",
      "Supervisor",
    ]),
    CrewSupplierMixin(),
    SupplierTypeMixin
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.Job, {}) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.Job),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  methods: {
    async createRepair(job) {
      this.$router.push({
        name: "service_repair_request.create",
        query: { job: job.id },
      });
    },
  },
  computed: {
    options() {
      return {
        CodeJobLocation: {
          options: this.optionCodeJobLocationItems,
          textField: "description",
          valueField: "id",
        },
        CodeJobType: {
          options: this.optionCodeJobTypeItems,
          textField: "description",
          valueField: "id",
        },
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Employee: {
          options: this.optionEmployeeItems,
          textField: "name",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "id",
        "site_address",
        "suburb",
        "wanted_pour_date",
        "pour_date",
        "crew_supplier",
        "pier_concrete_time",
        "create_request",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
